export const sxStyle = {
  roomsBox: {
    width: '100%',
    height: 'auto',
    borderRadius: '8px',
    bgcolor: '#FFFFFF',
    mt: { xs: '20px', sm: '40px' },
    mb: { xs: '20px', sm: 0 },
    border: { xs: '1px solid #E5E5E5', sm: '4px solid #E5E5E5' },
  },

  roomsFlexBox: {
    display: 'flex',
    p: { xs: '10px', sm: '30px' },
    pb: { xs: '10px', sm: 0 },
    mb: { xs: '-18px', sm: 0 },
  },
};
